import { render, staticRenderFns } from "./PasswordResetting.vue?vue&type=template&id=6bb3cd98&scoped=true&"
import script from "./PasswordResetting.vue?vue&type=script&lang=js&"
export * from "./PasswordResetting.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetting.vue?vue&type=style&index=0&id=6bb3cd98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb3cd98",
  null
  
)

export default component.exports